import s from "./_assocIndexOf.js";
var l = s, i = Array.prototype, o = i.splice;
function n(r) {
  var e = this.__data__, a = l(e, r);
  if (a < 0)
    return !1;
  var t = e.length - 1;
  return a == t ? e.pop() : o.call(e, a, 1), --this.size, !0;
}
var f = n;
export {
  f as default
};
//# sourceMappingURL=_listCacheDelete.js.map
